/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S20_Li4_AInputs */

const tr_mesafeli_s20_li4_a = /** @type {(inputs: Mesafeli_S20_Li4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şirketimiz ETBİS Kayıt No`)
};

const en_mesafeli_s20_li4_a = /** @type {(inputs: Mesafeli_S20_Li4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our company is registered under ETBİS registration number`)
};

const de_mesafeli_s20_li4_a = /** @type {(inputs: Mesafeli_S20_Li4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unser Unternehmen ist unter der ETBİS-Registriernummer`)
};

const ru_mesafeli_s20_li4_a = /** @type {(inputs: Mesafeli_S20_Li4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наша компания зарегистрирована под регистрационным номером ETBİS`)
};

/**
* | output |
* | --- |
* | "Our company is registered under ETBİS registration number" |
*
* @param {Mesafeli_S20_Li4_AInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s20_li4_a = /** @type {((inputs?: Mesafeli_S20_Li4_AInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S20_Li4_AInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s20_li4_a(inputs)
	if (locale === "de") return de_mesafeli_s20_li4_a(inputs)
	if (locale === "ru") return ru_mesafeli_s20_li4_a(inputs)
	return tr_mesafeli_s20_li4_a(inputs)
});